// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__2NaO-","primary":"input_primary__2vgSl"};